import { defineStore } from 'pinia';
import type { IProduct } from '~/modules/catalog/types/product';
import type { IUserData, TUserErrors } from '~/modules/user/types/user';

export const useUserStore = defineStore('userStore', () => {

  const { $api } = useNuxtApp();

  const userID = ref<number | undefined>();
  const userData = reactive<IUserData>({
    phone: '',
    email: '',
    inn: '',
    ogrn: '',
    name: '',
    user_type: null,
    gender: undefined,
    birthday: '',
    // address: {
    //   country: '',
    //   locality: '',
    //   house_number: '',
    //   apartment: '',
    //   street: ''
    // }
  });

  const orderTotalCount = ref<number>(0);
  const bonusBalance = ref<number>(0);
  const bonusBalanceLoaded = ref<boolean>(false);
  const bonusBalanceLoading = ref<boolean>(false);

  const setUserID = (id: number) => userID.value = id;
  const setUserData = (data: IUserData) => {
    const {
      phone,
      email,
      inn,
      ogrn,
      name,
      gender,
      birthday,
      user_type,
      address,
    } = data;

    Object.assign(userData, {
      phone: phone ? phone.slice(1) : '',
      email,
      inn,
      ogrn,
      name,
      user_type,
      gender,
      birthday,
      address,
    });
  };

  const clearUserData = () => {
    userID.value = undefined;
    userData.phone = '';
    userData.email = '';
    userData.inn = '';
    userData.ogrn = '';
    userData.name = '';
    userData.user_type = null;
    orderTotalCount.value = 0;
    bonusBalance.value = 0;
    bonusBalanceLoaded.value = false;
    bonusBalanceLoading.value = false;
  };

  const loadBonusBalance = async () => {
    if (userData.user_type === 'wholesale') return;
    if (bonusBalanceLoaded.value || bonusBalanceLoading.value) return;
    bonusBalanceLoading.value = true;
    try {
      const response = await $api.users.getBalance();
      if (response.success) {
        bonusBalance.value = response.data.available ?? 0;
        bonusBalanceLoaded.value = true;
      }
    } catch (e) {
      console.warn('Не удалось загрузить баланс бонусов', e);
    } finally {
      bonusBalanceLoading.value = false;
    }
  };

  const isWholesale = computed(() => userData.user_type === 'wholesale');
  const isRetail = computed(() => userData.user_type === null || userData.user_type === 'retail');

  return {
    userID,
    userData,
    isWholesale,
    isRetail,
    orderTotalCount,
    bonusBalance,
    bonusBalanceLoaded,
    bonusBalanceLoading,
    loadBonusBalance,
    setUserID,
    setUserData,
    clearUserData,
  };
});
